import React from 'react';
import './Bienvenida.css';

const Bienvenida = () => {
    return (
      <div className= "contendor-bienvenida">
        <div className= "mensaje-bienvenida">
            <p>
            Por favor verifique sus datos Fiscales, antes de realizar su pago ya que la factura se genera de forma automatica.
            </p>
        </div>
      </div>
    );
  };
  
export default Bienvenida;